import React, {useContext} from "react";
import moment from "moment";
import GlobalContext from "../GlobalContext";

const MonthNavigator = () => {

  const CONTEXT = useContext(GlobalContext);

  // type - prev/next
  function setDate(setSelectedDay, setSelectedMonth, setSelectedYear, type) {
    let newDate;

    if (type === 'prev') {
      newDate = moment([CONTEXT.selectedYear, CONTEXT.selectedMonth]).subtract(1, 'months');
    }
    if (type === 'next') {
      newDate = moment([CONTEXT.selectedYear, CONTEXT.selectedMonth]).add(1, 'months');
    }

    setSelectedDay(1);
    setSelectedMonth(newDate.month());
    setSelectedYear(newDate.year());
  }

  return (
    <div className="month-navigator row py-4">
      <GlobalContext.Consumer>
        {({
            setSelectedDay,
            setSelectedMonth,
            setSelectedYear
          }) => (
          <>
            <div className="prev col-3 text-right color-text-orange">
              <i onClick={() => setDate(
                setSelectedDay,
                setSelectedMonth,
                setSelectedYear,
                'prev'
              )}
                 className="fas fa-chevron-left cursor-pointer px-1"></i>
            </div>
            <div className="month-name col-6 text-center font-weight-bold">{createMonthWithOptionalYear(CONTEXT)}</div>
            <div className="next col-3 color-text-orange">
              <i onClick={() => setDate(
                setSelectedDay,
                setSelectedMonth,
                setSelectedYear,
                'next'
              )}
                 className="fas fa-chevron-right cursor-pointer px-1"></i>
            </div>
          </>
        )}
      </GlobalContext.Consumer>
    </div>
  );
};

function createMonthWithOptionalYear(CONTEXT) {
  const translatedMonth = CONTEXT.MONTHS_TRANSLATIONS[CONTEXT.selectedMonth];
  const selectedYear = CONTEXT.selectedYear;

  if (selectedYear > CONTEXT.eventsExtremeDates.newest || selectedYear < CONTEXT.eventsExtremeDates.oldest) {
    return `${translatedMonth} (${selectedYear})`;
  } else {
    return translatedMonth;
  }
}

export default MonthNavigator;
